import 'react-app-polyfill/ie9';
import 'promise-polyfill/src/polyfill';
import 'abortcontroller-polyfill';
import "es6-promise/auto";
import 'isomorphic-fetch';
import 'url-polyfill';
import 'core-js';
import ClipboardJS from 'clipboard';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { MsalProvider, } from "./Auth/msal-context";
import { msalConfig } from "./Auth/auth-config";

new ClipboardJS('.copy-btn');

ReactDOM.render(
  <MsalProvider config={msalConfig}>
    <App />
  </MsalProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
